import React from "react";
import Icon from "../../../components/AppIcon";

const DataTable = ({
  columns,
  data,
  isLoading,
  error,
  sortConfig,
  onSort,
  onRetry,
  emptyMessage,
  currentPage,
  itemsPerPage
}) => {
  const renderHeader = () => (
    <thead className="bg-gray-50 whitespace-nowrap">
      <tr>
        {columns.map((column) => (
          <th
            key={column.key}
            scope="col"
            className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${column.sortable ? "cursor-pointer select-none" : ""
              }`}
            onClick={() => column.sortable && onSort(column.key)}
          >
            <div className="flex items-center space-x-1">
              <span>{column.label}</span>
              {column.sortable && (
                <span className="inline-flex flex-col">
                  <Icon
                    name="ChevronUp"
                    size={12}
                    className={`${sortConfig.key === column.key &&
                      sortConfig.direction === "ascending"
                      ? "text-primary-600"
                      : "text-gray-400"
                      }`}
                  />
                  <Icon
                    name="ChevronDown"
                    size={12}
                    className={`${sortConfig.key === column.key &&
                      sortConfig.direction === "descending"
                      ? "text-primary-600"
                      : "text-gray-400"
                      } -mt-1`}
                  />
                </span>
              )}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );

  const renderRows = () => (
    <tbody className="bg-white divide-y divide-gray-200 whitespace-nowrap">
      {data.map((item, index) => (
        <tr key={item._id || index} className="hover:bg-gray-50">
          {columns.map((col) => {
            let value;

            if (col.key === "sno") {
              value = index + 1 + (currentPage - 1) * itemsPerPage;
            } else if (col.key === "createdAt" || col.key === "submittedAt") {
              const date = new Date(item[col.key]);
              value = isNaN(date.getTime()) ? "-" : date.toLocaleDateString();
            } else if (col.key === "preferredTopics") {
              // Handle array of preferred topics
              if (Array.isArray(item[col.key]) && item[col.key].length > 0) {
                value = item[col.key].join(", ");
              } else {
                value = "-";
              }
            } else {
              value = item[col.key] ?? "-";
            }

            return (
              <td
                key={col.key}
                className="px-6 py-4 whitespace-nowrap text-sm text-gray-700"
              >
                {value}
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  );

  const renderLoading = () => (
    <tbody className="bg-white divide-y divide-gray-200 whitespace-nowrap">
      {[...Array(3)].map((_, index) => (
        <tr key={index}>
          {columns.map((_, i) => (
            <td key={i} className="px-6 py-4">
              <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  const renderError = () => (
    <tbody className="whitespace-nowrap">
      <tr>
        <td colSpan={columns.length} className="px-6 py-12 text-center text-sm text-gray-500">
          <div className="flex flex-col items-center">
            <Icon name="AlertCircle" size={32} className="text-error mb-2" />
            <p className="font-medium mb-2">{error}</p>
            <button
              onClick={onRetry}
              className="mt-2 px-3 py-2 bg-primary-600 text-white text-sm rounded-md hover:bg-primary-700"
            >
              Retry
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  );

  const renderEmpty = () => (
    <tbody className="whitespace-nowrap">
      <tr>
        <td colSpan={columns.length} className="px-6 py-12 text-center text-sm text-gray-500">
          <div className="flex flex-col items-center">
            <Icon name="Search" size={32} className="text-gray-400 mb-2" />
            <p className="font-medium mb-2">{emptyMessage}</p>
          </div>
        </td>
      </tr>
    </tbody>
  );

  return (
    <div className="!overflow-x-auto">
      <table className="w-full">
        {renderHeader()}
        {isLoading
          ? renderLoading()
          : error
            ? renderError()
            : data.length === 0
              ? renderEmpty()
              : renderRows()}
      </table>
    </div>
  );
};

export default DataTable;
